import React from 'react';

interface IProps {
    separator?: JSX.Element | string;
}

export const Separator = (props: IProps) => {
    const { separator } = props;

    const render = () => {
        if (separator) {
            return separator;
        }
        return  <span className="separator">/</span>;
    };
    return (
        <>
            {render()}
        </>
    );
};
